import clsx from "clsx";

import { BillStatus } from "@/utils/enums";

// Status-colored text (Mahnung=error, Offen=warning, Bezahlt=success,
// Storniert=info).
const statusTextColor: Record<string, string> = {
  [BillStatus.reminder]: "text-foreground-error",
  [BillStatus.overdue]: "text-foreground-warning",
  [BillStatus.closed]: "text-foreground-success",
  [BillStatus.canceled]: "text-foreground-info",
};

export const BillStatusChip = ({
  status,
  label,
}: {
  status?: string;
  label: string;
}) => (
  <span
    className={clsx(
      // 4px/8px padding around a 12px semibold label whose container carries a
      // 2px bottom inset — that is what makes the pill exactly 22px tall.
      "inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-surface-quaternary px-2 pb-1.5 pt-1 text-xs font-semibold leading-none tracking-[0.24px]",
      status && statusTextColor[status]
        ? statusTextColor[status]
        : "text-foreground-primary",
    )}
  >
    {label}
  </span>
);
